import { render, staticRenderFns } from "./ProductReviewsModal.vue?vue&type=template&id=11400d04&"
import script from "./ProductReviewsModal.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports